package org.teddapp.project.ui.settings

import androidx.compose.runtime.staticCompositionLocalOf

/**
 * Pont entre le formulaire de connexion (UI) et la couche plateforme qui
 * instancie/détruit le SupabaseClient + SyncManager au runtime.
 *
 * Provisionné par main.kt (desktop) / MainActivity (Android) / MainViewController (iOS).
 *
 * Quand `LocalSupabaseConnector.current == null`, le formulaire affiche un message
 * "Connecteur non disponible" — devrait être rare puisque les 3 entrées d'app
 * le fournissent.
 */
interface SupabaseConnector {
    /** True si la sync est actuellement active (creds valides en mémoire). */
    val isConnected: Boolean

    /**
     * URL Supabase actuellement persistée (vide si jamais configurée).
     * Permet de pré-remplir le formulaire.
     */
    val currentUrl: String

    /**
     * Tente la connexion avec les credentials donnés.
     *  - Persiste URL + clé dans AppSettings
     *  - Recrée le SupabaseClient + SyncBindings
     *  - Active la sync (`syncEnabled = true`)
     * Retourne `null` en cas de succès, ou un message d'erreur lisible.
     */
    suspend fun connect(url: String, anonKey: String): String?

    /**
     * Déconnecte : efface les credentials, désactive la sync, détruit le client.
     */
    fun disconnect()
}

val LocalSupabaseConnector = staticCompositionLocalOf<SupabaseConnector?> { null }
